import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enPrayerRequest from './locales/en/prayerRequest.json';
import enAbout from './locales/en/about.json';
import enContact from './locales/en/contact.json';
import enFooter from './locales/en/footer.json';
import enLabels from './locales/en/labels.json';
import enGallery from './locales/en/gallery.json';
   

import esCommon from './locales/es/common.json';
import esPrayerRequest from './locales/es/prayerRequest.json';
import esAbout from './locales/es/about.json';
import esContact from './locales/es/contact.json';
import esFooter from './locales/es/footer.json';
import esLabels from './locales/es/labels.json';
import esGallery from './locales/es/gallery.json';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        prayerRequest: enPrayerRequest,
        about: enAbout,
        contact: enContact,
        footer: enFooter,
        labels: enLabels,
        gallery: enGallery,
      },
      es: {
        common: esCommon,
        prayerRequest: esPrayerRequest,
        about: esAbout,
        contact: esContact,
        footer: esFooter,
        labels: esLabels,
        gallery: esGallery,
      }
    },
    fallbackLng: 'en',
    ns: ['common', 'prayerRequest', 'about', 'contact', 'footer', 'labels', 'gallery'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
